/**
 * This is a "bridge" that allows redux actions to interact with the application notifications context,
 * i.e. open different notifications e.g. toasts, overlayBanners, etc. from within redux actions.
 *
 * It works by holding onto a reference of the applicationNotifications context, which is set from the
 * AuctionApp provider, and then allowing redux actions to get this reference and use it.
 */

let notificationsBridgeContext

export const setApplicationNotificationsBridgeContext = context => {
  notificationsBridgeContext = context
}

export const getApplicationNotificationsBridgeContext = () =>
  notificationsBridgeContext
